import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";

export default function ProcessNodes(root:LayoutNode,func:(node:LayoutNode)=>void){

    let openList = [root];


    while(openList.length>0){
        let evalNode = openList.pop();

        if(evalNode){
            func(evalNode);
            if(evalNode.children){
              for(let i = 0;i<evalNode.children.length;i++){
                    openList.push(evalNode.children[i]);
              }
            }
        }
    }


}